import { Grid, ListItemText, makeStyles, Typography } from '@material-ui/core';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

export const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#FAFAFA',
    padding: 10,
  },
  radio: {
    color: '#6FAD37 !important',
    '&$checked': {
      color: '#6FAD37 !important',
    },
  },
  checked: {},
  radioGenre: {
    background: '#FFFFFF',
    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '6px',
    paddingLeft: 10,
    marginRight: 10,
    marginLeft: 5,
  },
  inputTextStyle: {
    color: 'rgba(1, 1, 1, 1)',
    height: 40,
    width: '100%',
    '&.MuiInputBase-root': {
      border: '1px solid #C2D1D9',
      boxSizing: 'border-box',
      borderRadius: '3px',
    },
  },
  inputTextStyle2: {
    color: 'rgba(1, 1, 1, 1)',
    backgroundColor: 'white',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    height: 40,
    width: '100%',
    '&.MuiInputBase-root': {
      border: '1px solid #C2D1D9',
      boxSizing: 'border-box',
      borderRadius: '3px',
    },
    '& .MuiInputBase-input': {
      padding: '6px 16px 7px !important',
    },
  },
  inputDateStyle: {
    color: '#A2A8AB',
    backgroundColor: 'white',
    height: 40,
    width: '100%',
    '& .MuiInputBase-root': {
      boxSizing: 'border-box',
      borderRadius: '3px',
      height: 40,
    },
    '& .MuiInputBase-input': {
      padding: '6px 16px 7px !important',
      color: null,
    },
    '& .MuiOutlinedInput-input': {
      color: 'rgba(1, 1, 1, 1)',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
    },
  },
}));
export const StyledListItemText = styled(ListItemText)`
  span {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px !important;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: #2a2727;
  }
`;
export const StyledSecondaryTitle = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 13px;
  letter-spacing: 0.0763636px;
  color: #9797af;
  flex: none;
  order: 1;
  margin: 10px 0px;
`;
type ContentProps = {
  width?: string;
  fontSize?: string;
};
export const ContentLeft = styled.div<ContentProps>`
  float: left;
`;
export const ContentRight = styled.div<ContentProps>`
  float: right;
`;
export const CardRecap = styled.div`
  background: #f9f9f9;
  border: 1px solid rgba(192, 197, 207, 0.3);
  box-sizing: border-box;
  border-radius: 13.5px;
  width: 100%;
  overflow: auto;
  height: auto;
  padding: 10px;
  margin-bottom: 20px;
`;
export const PrimaryTitleCard = styled(Typography)<ContentProps>`
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : '14px'} !important;
  line-height: 16px !important;
  color: #333333 !important;
`;

export const ContentTitle = styled(Typography)<ContentProps>`
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : '14px'} !important;
  line-height: 20px !important;
  color: #494949 !important;
`;

export const ContentSecondTitle = styled(Typography)<ContentProps>`
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '12px')}!important;
  text-align: right !important;
  line-height: 20px !important;
  letter-spacing: 0.0636364px !important;
  color: #9797af !important;
`;
export const IconModify = styled.img`
  cursor: pointer;
`;
export const FolderTypeSecondaryContent = styled.div`
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  border-radius: 13.5px;
  width: 100%;
  overflow: auto;
  height: auto;
  padding: 15px;
  align-items: center;
`;
export const StyledDropZoneContainer = styled(Grid)`
  &&&& {
    .MuiSnackbarContent-root {
      color: #fff;
      display: flex;
      padding: 6px 16px;
      flex-grow: 1;
      flex-wrap: wrap;
      font-size: 0.875rem;
      align-items: center;
      font-family: Roboto;
      font-weight: 400;
      line-height: 1.43;
    }
    .MuiDropzoneArea-root {
      min-height: 1px !important;
      max-height: 70px;
      border: 1px dashed rgba(0, 117, 201, 0.53);
      border-radius: 8px;
      padding: 0px 10px;
      backgound-color: #fff;
      margin-bottom: 30px;
    }
    .MuiDropzonePreviewList-removeButton {
      background-color: #fafafb;
      box-shadow: none;
      color: #9ba0ad;
      opacity: 1;
      top: 25px;
      right: 25px;
      left: 450px;
      @media (max-width: ${breakpoints.xs}) {
        left: 240px;
      }
    }
    .MuiDropzonePreviewList-imageContainer {
      text-align: left;
    }
    .MuiDropzoneArea-text {
      color: #9ea4b3;
      font-size: 12px;
      font-weight: 300;
      margin-left: 35px;
      @media (max-width: ${breakpoints.xs}) {
        margin-left: 60px;
        margin-top: 10px;
      }
    }
    .MuiDropzoneArea-icon {
      color: #cfd2da;
      position: relative !important;
      bottom: 60px !important;
      float: left;
      @media (max-width: ${breakpoints.xs}) {
        bottom: 75px !important;
      }
    }
    .MuiTypography-subtitle1 {
      display: none;
    }
  }
`;
export const ImageWrapper = styled(Grid)`
  background-color: #f3f3f3;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 12px;
  align-items: center;
`;
export const UploadBoxRecap = styled(Grid)`
  background-color: white;
  mix-blend-mode: normal;
  border: 1px solid rgba(150, 150, 150, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  padding-left: 22px;
  padding-right: 22px;
  padding-top: 15px;
`;
export const UploadBoxTitle = styled.p`
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  margin: 0;
  color: #616c78 !important;
`;
export const UploadBoxSecondTitle = styled.p`
  font-family: 'Roboto' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  color: #9ea4b3 !important;
`;

export const ErrorTitle = styled.p`
  font-family: 'Roboto' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  color: red !important;
  margin: 0;
`;

export const ContentText = styled(Typography)<ContentProps>`
  font-family: Roboto !important;
  font-size: ${(props) =>
    props.fontSize ? props.fontSize : '14px'} !important;
  font-weight: 400 !important;
  line-height: 17px !important;
  letter-spacing: 0em !important;
  text-align: center !important;
  color: #8b8b8b !important;
`;
